/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export type FaqContentEntity = object;

export interface CreateFaqContentBodyDto {
  subjectFi: string;
  subjectSv?: string;
  subjectEn?: string;
  answerFi: string;
  answerSv?: string;
  answerEn?: string;
}

export interface MultilingualKeyDto {
  fi: string;
  en: string;
  sv: string;
}

export interface FaqContentDto {
  id: number;
  subject: MultilingualKeyDto;
  answer: MultilingualKeyDto;
  listIndex: number | null;
}

export interface CreateFaqContentOkResponseDto {
  message: string;
  faqContent: FaqContentDto;
}

export interface UpdateFAQContentBodyDto {
  subjectFi?: string;
  subjectSv?: string;
  subjectEn?: string;
  answerFi?: string;
  answerSv?: string;
  answerEn?: string;
}

export interface DeleteFaqContentOkResponseDto {
  message: string;
  faqContent: FaqContentDto;
}

export interface PublishPlatformDto {
  id: number;
  name: MultilingualKeyDto;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface FaqCategoryDto {
  id: number;
  name: MultilingualKeyDto;
  contents: FaqContentDto[];
  publishPlatforms: PublishPlatformDto[];
  listIndex: number | null;
}

export interface CreateFAQCategoryBodyDto {
  nameFi: string;
  nameSv?: string;
  nameEn?: string;
  userRoleIds?: number[];
  publishPlatformIds: number[];
}

export interface CreateFaqCategoryOkResponseDto {
  message: string;
  faqCategory: FaqCategoryDto;
}

export interface UpdateFAQCategoryBodyDto {
  nameFi?: string;
  nameSv?: string;
  nameEn?: string;
  publishPlatformIds?: number[];
}

export interface UpdateFaqCategoryOkResponseDto {
  message: string;
  faqCategory: FaqCategoryDto;
}

export interface DeleteFaqCategoryOkResponseDto {
  message: string;
  faqCategory: FaqCategoryDto;
}

export interface FaqListPositionIdentifierDto {
  id: number;
  listIndex: number;
}

export interface UpdateFAQListIndexesBodyDto {
  categories?: FaqListPositionIdentifierDto[];
  contents?: FaqListPositionIdentifierDto[];
}

export interface UpdateFaqListIndexesOkResponseDto {
  message: string;
  faqCategories: string[];
}

export type EntityTimestamps = object;

export interface ContentImagesDto {
  desktop: string;
  desktopLarge: string;
  mobile: string;
}

export interface NewsletterCategoryDto {
  id: number;
  name: MultilingualKeyDto;
  isVisible: boolean;
  newsletters: NewsletterDto[];
  newsletterCount: number;
}

export interface TagDto {
  id: number;
  name: MultilingualKeyDto;
}

export interface ActionLogDto {
  id: number;
  /** @format date-time */
  timestamp: string;
  resource:
    | "mobile-material"
    | "mobile-material-category"
    | "faq-category"
    | "faq-content"
    | "tag"
    | "newsletter"
    | "newsletter-category"
    | "pharmac-expert"
    | "service-description"
    | "banner";
  action: "create" | "delete" | "update";
  triggeredBy: string;
}

export interface NewsletterDto {
  id: number;
  title: MultilingualKeyDto;
  content: MultilingualKeyDto;
  image: ContentImagesDto;
  /** @format date-time */
  visibilityStartDate: string;
  /** @format date-time */
  visibilityEndDate: string;
  category: NewsletterCategoryDto;
  tags: TagDto[];
  isVisible: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  publishPlatforms: PublishPlatformDto[];
  history: ActionLogDto[];
}

export interface CreateNewsletterCategoryBodyDto {
  nameFi?: string;
  nameSv?: string;
  nameEn?: string;
  isVisible?: boolean;
}

export interface CreateNewsletterCategoryOkResponseDto {
  message: string;
  newsletterCategory: NewsletterCategoryDto;
}

export interface UpdateNewsletterCategoryBodyDto {
  nameFi?: string;
  nameSv?: string;
  nameEn?: string;
  isVisible?: boolean;
}

export interface DeleteNewsletterCategoryOkResponseDto {
  message: string;
  newsletterCategory: NewsletterCategoryDto;
}

export interface MobileMaterialCategoryDto {
  id: number;
  name: MultilingualKeyDto;
  isVisible: boolean;
  materialCount: number;
}

export interface CreateMobileMaterialCategoryBodyDto {
  nameFi: string;
  nameSv?: string;
  nameEn?: string;
}

export interface CreateMobileMaterialCategoryOkResponse {
  message: string;
  mobileMaterialCategory: MobileMaterialCategoryDto;
}

export interface UpdateMobileMaterialCategoryBodyDto {
  nameFi: string;
  nameSv: string;
  nameEn: string;
}

export interface UpdateMobileMaterialCategoryOkResponse {
  message: string;
  mobileMaterialCategory: MobileMaterialCategoryDto;
}

export interface DeleteMobileMaterialCategoryOkResponse {
  message: string;
  mobileMaterialCategory: MobileMaterialCategoryDto;
}

export interface GetMobileMaterialsQueryDto {
  categoryId?: number;
  isVisible?: boolean;
}

export interface FocusGroupDto {
  id: number;
  type: string;
  name: MultilingualKeyDto;
}

export interface MobileMaterialDto {
  id: number;
  materialType: string;
  materialLink: string;
  name: MultilingualKeyDto;
  image: ContentImagesDto;
  description: MultilingualKeyDto;
  isVisible: boolean;
  categories: MobileMaterialCategoryDto[];
  focusGroups: FocusGroupDto[];
  history: ActionLogDto[];
  publishPlatforms: PublishPlatformDto[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface CreateMobileMaterialBodyDto {
  materialType: string;
  nameFi: string;
  nameEn?: string;
  nameSv?: string;
  descriptionFi: string;
  descriptionSv?: string;
  descriptionEn?: string;
  isVisible?: boolean;
  desktopImage?: string;
  desktopImageLarge?: string;
  mobileImage: string;
  materialLink?: string;
  categoryIds: number[];
  focusGroupIds: number[];
  publishPlatformIds: number[];
}

export interface CreateMobileMaterialOkResponse {
  message: string;
  mobileMaterial: MobileMaterialDto;
}

export interface UpdateMobileMaterialBodyDto {
  materialType: string;
  nameFi?: string;
  nameEn?: string;
  nameSv?: string;
  descriptionFi?: string;
  descriptionEn?: string;
  descriptionSv?: string;
  isVisible?: boolean;
  desktopImage?: string;
  desktopImageLarge?: string;
  mobileImage?: string;
  materialLink?: string;
  categoryIds?: number[];
  focusGroupIds?: number[];
  publishPlatformIds?: number[];
}

export interface UpdateMobileMaterialOkResponse {
  message: string;
  mobileMaterial: MobileMaterialDto;
}

export interface DeleteMobileMaterialOkResponse {
  message: string;
  mobileMaterial: MobileMaterialDto;
}

export interface GetNewslettersQueryDto {
  title?: string;
  categoryId?: number;
  categoryIds?: string[];
  limit?: number;
  isVisible?: boolean;
}

export interface CreateNewsletterBodyDto {
  titleFi: string;
  titleSv?: string;
  titleEn?: string;
  contentFi: string;
  contentSv?: string;
  contentEn?: string;
  categoryId: number;
  category?: string;
  /** @format date-time */
  visibilityStartDate: string;
  /** @format date-time */
  visibilityEndDate?: string;
  isVisible?: boolean;
  isPharmacist?: boolean;
  userRoleIds: number[];
  desktopImage?: string;
  desktopImageLarge?: string;
  mobileImage: string;
  publishPlatformIds?: number[];
  tagIds?: number[];
}

export type CreateNewsletterOkResponseDto = object;

export interface UpdateNewsletterBodyDto {
  titleFi?: string;
  titleSv?: string;
  titleEn?: string;
  contentFi?: string;
  contentSv?: string;
  contentEn?: string;
  category?: string;
  categoryId?: number;
  isVisible?: boolean;
  isPharmacist?: boolean;
  /** @format date-time */
  visibilityStartDate?: string;
  /** @format date-time */
  visibilityEndDate?: string;
  userRoleIds?: number[];
  desktopImage?: string;
  desktopImageLarge?: string;
  mobileImage?: string;
  publishPlatformIds?: number[];
  tagIds?: number[];
}

export type UpdateNewsletterOkResponseDto = object;

export type DeleteNewsletterOkResponseDto = object;

export interface CreateTagBodyDto {
  nameFi: string;
  nameSv?: string;
  nameEn?: string;
}

export type CreateTagOkResponseDto = object;

export interface UpdateTagBodyDto {
  nameFi?: string;
  nameSv?: string;
  nameEn?: string;
}

export type UpdateTagOkResponseDto = object;

export type DeleteTagOkResponseDto = object;

export interface MediabankMediaFileDto {
  id: string;
  mediaId: number;
  url: string;
  ratio: object;
  /** @format date-time */
  created: string;
}

export interface MediabankMediaDto {
  id: number;
  name: string;
  thumbnail: string;
  thumbnailUrl: string;
  /** @format date-time */
  created: string;
  mediaFiles: MediabankMediaFileDto[];
}

export interface MediabankMediaLinksDto {
  desktopImage: string;
  desktopImageLarge: string;
  mobileImage: string;
}

export interface PharmacExpertDto {
  id: number;
  firstName: string;
  lastName: string;
  info: MultilingualKeyDto;
  additionalInfo: MultilingualKeyDto;
  image: ContentImagesDto;
  meetingLink: string;
  services: any[][];
}

export interface ServiceDescriptionDto {
  id: number;
  image: ContentImagesDto;
  slug: MultilingualKeyDto;
  title: MultilingualKeyDto;
  content: MultilingualKeyDto;
  header: MultilingualKeyDto;
  banner: MultilingualKeyDto;
  experts: PharmacExpertDto[];
}

export interface CreateServiceDescriptionBodyDto {
  slugFi?: string;
  slugEn?: string;
  slugSv?: string;
  desktopImage?: string;
  desktopImageLarge?: string;
  mobileImage?: string;
  titleFi: string;
  titleEn?: string;
  titleSv?: string;
  menuLabelFi?: string;
  menuLabelEn?: string;
  menuLabelSv?: string;
  bannerFi: string;
  bannerEn?: string;
  bannerSv?: string;
  headerFi: string;
  headerEn?: string;
  headerSv?: string;
  contentFi: string;
  contentEn?: string;
  contentSv?: string;
  experts?: number[];
}

export interface CreateServiceDescriptionOkResponseDto {
  message: string;
  serviceDescription: ServiceDescriptionDto;
}

export interface UpdateServiceDescriptionBodyDto {
  slugFi?: string;
  slugEn?: string;
  slugSv?: string;
  desktopImage?: string;
  desktopImageLarge?: string;
  mobileImage?: string;
  titleFi?: string;
  titleEn?: string;
  titleSv?: string;
  menuLabelFi?: string;
  menuLabelEn?: string;
  menuLabelSv?: string;
  bannerFi?: string;
  bannerSv?: string;
  bannerEn?: string;
  headerFi?: string;
  headerSv?: string;
  headerEn?: string;
  contentFi?: string;
  contentSv?: string;
  contentEn?: string;
  pharmacExpertIds?: number[];
}

export interface UpdateServiceDescriptionOkResponseDto {
  message: string;
  serviceDescription: ServiceDescriptionDto;
}

export interface DeleteServiceDescriptionOkResponseDto {
  message: string;
  serviceDescription: ServiceDescriptionDto;
}

export enum BannerViewEnum {
  Frontpage = "frontpage",
  Shop = "shop",
  Newsletters = "newsletters",
  DispensingProducts = "dispensing-products",
}

export interface BannerDto {
  id: number;
  title: MultilingualKeyDto;
  /** @format date */
  visibilityStartDate: string;
  /** @format date */
  visibilityEndDate: string;
  isVisible: boolean;
  /** @format date */
  createdAt: string;
  /** @format date */
  updatedAt: string;
  url: MultilingualKeyDto;
  image: MultilingualKeyDto;
  mobileImage: MultilingualKeyDto;
  history: ActionLogDto[];
  view: BannerViewEnum;
  professionalRoleIds: number[];
}

export interface ExtranetCustomerUserProfessionalRoleDto {
  id: number;
  role: string;
  isActive: boolean;
  displayName: MultilingualKeyDto;
}

export interface CreateBannerBodyDto {
  titleFi: string;
  titleSv?: string;
  titleEn?: string;
  urlFi: string;
  urlSv?: string;
  urlEn?: string;
  imageFi: string;
  imageSv?: string;
  imageEn?: string;
  mobileImageFi: string;
  mobileImageSv?: string;
  mobileImageEn?: string;
  view: BannerViewEnum;
  /** @format date-time */
  visibilityStartDate: string;
  /** @format date-time */
  visibilityEndDate?: string;
  isVisible?: boolean;
  professionalRoleIds?: number[];
}

export interface CreateBannerOkResponseDto {
  message: string;
  banner: BannerDto;
}

export interface UpdateBannerBodyDto {
  titleFi?: string;
  titleSv?: string;
  titleEn?: string;
  urlFi?: string;
  urlSv?: string;
  urlEn?: string;
  imageFi?: string;
  imageSv?: string;
  imageEn?: string;
  mobileImageFi?: string;
  mobileImageSv?: string;
  mobileImageEn?: string;
  /** @format date-time */
  visibilityStartDate?: string;
  /** @format date-time */
  visibilityEndDate?: string;
  isVisible?: boolean;
  view?: BannerViewEnum;
  bannerId?: number;
  professionalRoleIds?: number[];
}

export interface UpdateBannerOkResponseDto {
  message: string;
  banner: BannerDto;
}

export interface DeleteBannerOkResponseDto {
  message: string;
  banner: BannerDto;
}

export interface GetManagementHeartbeatResponseDto {
  timestamp: number;
  message: string;
}

export interface GetManagementSystemVersionResponseDto {
  timestamp: number;
  message: string;
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { "Content-Type": type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data);
  };
}

/**
 * @title Extranet Management API
 * @version 1.0
 * @contact
 *
 * Extranet Management API
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  faqs = {
    /**
     * No description
     *
     * @name GetFaqContents
     * @request GET:/v1/faqs/contents
     */
    getFaqContents: (params: RequestParams = {}) =>
      this.request<FaqContentEntity[], any>({
        path: `/v1/faqs/contents`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetContentById
     * @request GET:/v1/faqs/contents/{id}
     */
    getContentById: (id: number, params: RequestParams = {}) =>
      this.request<FaqContentEntity, any>({
        path: `/v1/faqs/contents/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateContent
     * @request PUT:/v1/faqs/contents/{id}
     */
    updateContent: (id: number, data: UpdateFAQContentBodyDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/faqs/contents/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteContent
     * @request DELETE:/v1/faqs/contents/{id}
     */
    deleteContent: (id: number, params: RequestParams = {}) =>
      this.request<DeleteFaqContentOkResponseDto, any>({
        path: `/v1/faqs/contents/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CreateContent
     * @request POST:/v1/faqs/categories/{categoryId}/contents
     */
    createContent: (categoryId: number, data: CreateFaqContentBodyDto, params: RequestParams = {}) =>
      this.request<CreateFaqContentOkResponseDto, any>({
        path: `/v1/faqs/categories/${categoryId}/contents`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCategories
     * @request GET:/v1/faqs/categories
     */
    getCategories: (params: RequestParams = {}) =>
      this.request<FaqCategoryDto[], any>({
        path: `/v1/faqs/categories`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CreateCategory
     * @request POST:/v1/faqs/categories
     */
    createCategory: (data: CreateFAQCategoryBodyDto, params: RequestParams = {}) =>
      this.request<CreateFaqCategoryOkResponseDto, any>({
        path: `/v1/faqs/categories`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateCategory
     * @request PUT:/v1/faqs/categories/{id}
     */
    updateCategory: (id: number, data: UpdateFAQCategoryBodyDto, params: RequestParams = {}) =>
      this.request<UpdateFaqCategoryOkResponseDto, any>({
        path: `/v1/faqs/categories/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteCategory
     * @request DELETE:/v1/faqs/categories/{id}
     */
    deleteCategory: (id: number, params: RequestParams = {}) =>
      this.request<DeleteFaqCategoryOkResponseDto, any>({
        path: `/v1/faqs/categories/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateListIndexes
     * @request PUT:/v1/faqs/listIndexes
     */
    updateListIndexes: (data: UpdateFAQListIndexesBodyDto, params: RequestParams = {}) =>
      this.request<UpdateFaqListIndexesOkResponseDto, any>({
        path: `/v1/faqs/listIndexes`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  newsletterCategories = {
    /**
     * No description
     *
     * @name GetCategories
     * @request GET:/v1/newsletter-categories
     */
    getCategories: (params: RequestParams = {}) =>
      this.request<NewsletterCategoryDto[], any>({
        path: `/v1/newsletter-categories`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CreateCategory
     * @request POST:/v1/newsletter-categories
     */
    createCategory: (data: CreateNewsletterCategoryBodyDto, params: RequestParams = {}) =>
      this.request<CreateNewsletterCategoryOkResponseDto, any>({
        path: `/v1/newsletter-categories`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCategory
     * @request GET:/v1/newsletter-categories/{id}
     */
    getCategory: (id: number, params: RequestParams = {}) =>
      this.request<NewsletterCategoryDto, any>({
        path: `/v1/newsletter-categories/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateCategory
     * @request PUT:/v1/newsletter-categories/{categoryId}
     */
    updateCategory: (categoryId: number, data: UpdateNewsletterCategoryBodyDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/newsletter-categories/${categoryId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteCategory
     * @request DELETE:/v1/newsletter-categories/{categoryId}
     */
    deleteCategory: (categoryId: number, params: RequestParams = {}) =>
      this.request<DeleteNewsletterCategoryOkResponseDto, any>({
        path: `/v1/newsletter-categories/${categoryId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  mobileMaterialCategories = {
    /**
     * No description
     *
     * @name GetCategories
     * @request GET:/v1/mobile-material-categories
     */
    getCategories: (params: RequestParams = {}) =>
      this.request<MobileMaterialCategoryDto[], any>({
        path: `/v1/mobile-material-categories`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CreateCategory
     * @request POST:/v1/mobile-material-categories
     */
    createCategory: (data: CreateMobileMaterialCategoryBodyDto, params: RequestParams = {}) =>
      this.request<CreateMobileMaterialCategoryOkResponse, any>({
        path: `/v1/mobile-material-categories`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCategory
     * @request GET:/v1/mobile-material-categories/{id}
     */
    getCategory: (id: number, params: RequestParams = {}) =>
      this.request<MobileMaterialCategoryDto, any>({
        path: `/v1/mobile-material-categories/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateCategory
     * @request PUT:/v1/mobile-material-categories/{id}
     */
    updateCategory: (id: number, data: UpdateMobileMaterialCategoryBodyDto, params: RequestParams = {}) =>
      this.request<UpdateMobileMaterialCategoryOkResponse, any>({
        path: `/v1/mobile-material-categories/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteCategory
     * @request DELETE:/v1/mobile-material-categories/{id}
     */
    deleteCategory: (id: number, params: RequestParams = {}) =>
      this.request<DeleteMobileMaterialCategoryOkResponse, any>({
        path: `/v1/mobile-material-categories/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  mobileMaterials = {
    /**
     * No description
     *
     * @tags mobile-materials
     * @name GetMaterials
     * @request GET:/v1/mobile-materials
     */
    getMaterials: (
      query?: {
        categoryId?: number;
        isVisible?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, MobileMaterialDto[]>({
        path: `/v1/mobile-materials`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags mobile-materials
     * @name CreateMaterial
     * @request POST:/v1/mobile-materials
     */
    createMaterial: (data: CreateMobileMaterialBodyDto, params: RequestParams = {}) =>
      this.request<CreateMobileMaterialOkResponse, any>({
        path: `/v1/mobile-materials`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags mobile-materials
     * @name GetMaterialById
     * @request GET:/v1/mobile-materials/{id}
     */
    getMaterialById: (id: number, params: RequestParams = {}) =>
      this.request<MobileMaterialDto, any>({
        path: `/v1/mobile-materials/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags mobile-materials
     * @name UpdateMaterial
     * @request PUT:/v1/mobile-materials/{id}
     */
    updateMaterial: (id: number, data: UpdateMobileMaterialBodyDto, params: RequestParams = {}) =>
      this.request<UpdateMobileMaterialOkResponse, any>({
        path: `/v1/mobile-materials/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags mobile-materials
     * @name DeleteMaterial
     * @request DELETE:/v1/mobile-materials/{id}
     */
    deleteMaterial: (id: number, params: RequestParams = {}) =>
      this.request<DeleteMobileMaterialOkResponse, any>({
        path: `/v1/mobile-materials/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  newsletters = {
    /**
     * No description
     *
     * @name GetNewsletters
     * @request GET:/v1/newsletters
     */
    getNewsletters: (
      query?: {
        title?: string;
        categoryId?: number;
        categoryIds?: string[];
        limit?: number;
        isVisible?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<NewsletterDto[], any>({
        path: `/v1/newsletters`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CreateNewsletter
     * @request POST:/v1/newsletters
     */
    createNewsletter: (data: CreateNewsletterBodyDto, params: RequestParams = {}) =>
      this.request<CreateNewsletterOkResponseDto, any>({
        path: `/v1/newsletters`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetNewsletterById
     * @request GET:/v1/newsletters/{id}
     */
    getNewsletterById: (id: number, params: RequestParams = {}) =>
      this.request<NewsletterDto, any>({
        path: `/v1/newsletters/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateNewsletter
     * @request PUT:/v1/newsletters/{id}
     */
    updateNewsletter: (id: number, data: UpdateNewsletterBodyDto, params: RequestParams = {}) =>
      this.request<UpdateNewsletterOkResponseDto, any>({
        path: `/v1/newsletters/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteNewsletter
     * @request DELETE:/v1/newsletters/{id}
     */
    deleteNewsletter: (id: number, params: RequestParams = {}) =>
      this.request<DeleteNewsletterOkResponseDto, any>({
        path: `/v1/newsletters/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  tags = {
    /**
     * No description
     *
     * @name GetTags
     * @request GET:/v1/tags
     */
    getTags: (params: RequestParams = {}) =>
      this.request<TagDto[], any>({
        path: `/v1/tags`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CreateTag
     * @request POST:/v1/tags/tag
     */
    createTag: (data: CreateTagBodyDto, params: RequestParams = {}) =>
      this.request<CreateTagOkResponseDto, any>({
        path: `/v1/tags/tag`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateTag
     * @request PUT:/v1/tags/tag/{id}
     */
    updateTag: (id: number, data: UpdateTagBodyDto, params: RequestParams = {}) =>
      this.request<UpdateTagOkResponseDto, any>({
        path: `/v1/tags/tag/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteTag
     * @request DELETE:/v1/tags/tag/{id}
     */
    deleteTag: (id: number, params: RequestParams = {}) =>
      this.request<DeleteTagOkResponseDto, any>({
        path: `/v1/tags/tag/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  publishPlatforms = {
    /**
     * No description
     *
     * @name GetPublishPlatforms
     * @request GET:/v1/publish-platforms
     */
    getPublishPlatforms: (params: RequestParams = {}) =>
      this.request<PublishPlatformDto[], any>({
        path: `/v1/publish-platforms`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  mediabank = {
    /**
     * No description
     *
     * @name GetMedia
     * @request GET:/v1/mediabank
     */
    getMedia: (params: RequestParams = {}) =>
      this.request<MediabankMediaDto[], any>({
        path: `/v1/mediabank`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetMediaLinksById
     * @request GET:/v1/mediabank/{id}
     */
    getMediaLinksById: (id: number, params: RequestParams = {}) =>
      this.request<MediabankMediaLinksDto, any>({
        path: `/v1/mediabank/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  services = {
    /**
     * No description
     *
     * @name GetServiceDescriptions
     * @request GET:/v1/services
     */
    getServiceDescriptions: (params: RequestParams = {}) =>
      this.request<ServiceDescriptionDto[], any>({
        path: `/v1/services`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CreateServiceDescription
     * @request POST:/v1/services
     */
    createServiceDescription: (data: CreateServiceDescriptionBodyDto, params: RequestParams = {}) =>
      this.request<CreateServiceDescriptionOkResponseDto, any>({
        path: `/v1/services`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetServiceDescription
     * @request GET:/v1/services/{id}
     */
    getServiceDescription: (id: number, params: RequestParams = {}) =>
      this.request<ServiceDescriptionDto, any>({
        path: `/v1/services/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateServiceDescription
     * @request PUT:/v1/services/{id}
     */
    updateServiceDescription: (id: number, data: UpdateServiceDescriptionBodyDto, params: RequestParams = {}) =>
      this.request<UpdateServiceDescriptionOkResponseDto, any>({
        path: `/v1/services/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteServiceDescription
     * @request DELETE:/v1/services/{id}
     */
    deleteServiceDescription: (id: number, params: RequestParams = {}) =>
      this.request<DeleteServiceDescriptionOkResponseDto, any>({
        path: `/v1/services/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  banners = {
    /**
     * No description
     *
     * @name GetBanners
     * @request GET:/v1/banners
     */
    getBanners: (params: RequestParams = {}) =>
      this.request<BannerDto[], any>({
        path: `/v1/banners`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CreateBanner
     * @request POST:/v1/banners
     */
    createBanner: (data: CreateBannerBodyDto, params: RequestParams = {}) =>
      this.request<CreateBannerOkResponseDto, any>({
        path: `/v1/banners`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GeProfessionalRoles
     * @request GET:/v1/banners/professional-roles
     */
    geProfessionalRoles: (params: RequestParams = {}) =>
      this.request<ExtranetCustomerUserProfessionalRoleDto[], any>({
        path: `/v1/banners/professional-roles`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetBanner
     * @request GET:/v1/banners/{id}
     */
    getBanner: (id: number, params: RequestParams = {}) =>
      this.request<BannerDto, any>({
        path: `/v1/banners/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateBanner
     * @request PUT:/v1/banners/{id}
     */
    updateBanner: (id: number, data: UpdateBannerBodyDto, params: RequestParams = {}) =>
      this.request<UpdateBannerOkResponseDto, any>({
        path: `/v1/banners/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteBanner
     * @request DELETE:/v1/banners/{id}
     */
    deleteBanner: (id: number, params: RequestParams = {}) =>
      this.request<DeleteBannerOkResponseDto, any>({
        path: `/v1/banners/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  heartbeat = {
    /**
     * No description
     *
     * @name GetHeartbeat
     * @request GET:/v1/heartbeat
     */
    getHeartbeat: (params: RequestParams = {}) =>
      this.request<GetManagementHeartbeatResponseDto, any>({
        path: `/v1/heartbeat`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  systemVersion = {
    /**
     * No description
     *
     * @name GetSystemVersion
     * @request GET:/v1/system-version
     */
    getSystemVersion: (params: RequestParams = {}) =>
      this.request<GetManagementSystemVersionResponseDto, any>({
        path: `/v1/system-version`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
